import { MenuItem, styled } from '@mui/material';
import { GridDensity } from '@mui/x-data-grid-premium';
import { useAppTFunction } from '@retail/app/i18n';
import TableRowsIcon from '@mui/icons-material/TableRows';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import { Menu, MenuButton } from '../Menu';

interface Props {
  density: GridDensity;
  onDensityChange: (density: GridDensity) => void;
}

export function DensityMenu({ density, onDensityChange }: Props) {
  const t = useAppTFunction();

  return (
    <Menu>
      {({ onClose }) => {
        const selectDensity = (value: GridDensity) => {
          onDensityChange(value);
          onClose();
        };

        return (
          <>
            <MenuButton
              size="small"
              sx={{ color: 'grey.800', boxShadow: 'none', backgroundColor: 'transparent' }}
            >
              <TableRowsIcon sx={{ mr: 1 }} />
              {t('common.density.title')}
            </MenuButton>

            <StyledMenuItem
              onClick={() => selectDensity('compact')}
              selected={density === 'compact'}
              hasBorderTop={false}
            >
              <ViewHeadlineIcon /> {t('common.density.compact')}
            </StyledMenuItem>
            <StyledMenuItem
              onClick={() => selectDensity('standard')}
              selected={density === 'standard'}
            >
              <TableRowsIcon /> {t('common.density.standard')}
            </StyledMenuItem>
            <StyledMenuItem
              onClick={() => selectDensity('comfortable')}
              selected={density === 'comfortable'}
            >
              <ViewStreamIcon /> {t('common.density.comfortable')}
            </StyledMenuItem>
          </>
        );
      }}
    </Menu>
  );
}

const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== 'hasBorderTop',
})<{ hasBorderTop?: boolean }>(({ theme, hasBorderTop = true }) => ({
  width: 220,
  color: theme.vars.palette.grey[800],
  borderTop: hasBorderTop ? undefined : 'none',

  '.MuiSvgIcon-root': {
    fill: theme.vars.palette.grey[800],
  },
}));
